import { render, staticRenderFns } from "./customerAbbreviationSample.vue?vue&type=template&id=5d586b5c&scoped=true&"
import script from "./customerAbbreviationSample.vue?vue&type=script&lang=js&"
export * from "./customerAbbreviationSample.vue?vue&type=script&lang=js&"
import style0 from "./customerAbbreviationSample.vue?vue&type=style&index=0&id=5d586b5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d586b5c",
  null
  
)

export default component.exports